import type { NavId } from './last-selected-nav';

/**
 * Which rail item the shell highlights (PROD-3203 M4).
 *
 * Settings is not a rail destination: it opens from the profile menu. On a
 * `/settings*` page the shell's `activeNav` still falls back to the last root
 * view (Calendar by default), and the rail used to highlight that. Settings
 * now highlights nothing.
 *
 * One exception (Ahmed, 28 Oct): Lab settings opened from Billing › Labs is
 * Settings › Clinic services marked `?from=labs`. Its breadcrumb reads
 * Billing › Master Data › Labs › Lab settings (`top-bar.tsx`), so the rail
 * agrees and highlights Billing.
 */
export function railActiveId(pathname: string, activeNav: NavId, search = ''): NavId | null {
  if (/^\/settings\/clinic-services\/?$/.test(pathname) && new URLSearchParams(search).get('from') === 'labs') {
    return 'billing';
  }
  return /^\/settings(\/|$)/.test(pathname) ? null : activeNav;
}
